import { Division } from './division.dto';
import { Auditable, Dto, KeyValue } from '@damofire/data-commons';

export interface Organization extends Dto<string>, Auditable {
  divisions?: KeyValue<string, string>[];
  enabled?: boolean;
  name?: string;
  shortName?: string;
  principal?: Division;
  types?: string[];
  taxId?: string;
}

export interface PartialOrganization {
  _id?: string;
  name?: string;
}

export interface PartialDivision {
  _id?: string;
  name?: string;
}

export interface OrganizationInfos<T = string> extends Dto<T> {
  organization?: PartialOrganization;
  division?: PartialDivision;
  enabled?: boolean;
}

export type DivisionEmailExclusion = string;
